import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useUnavailableFeatureTooltipStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.text.primary,
    fontSize: 13,
    fontWeight: 600,
    maxWidth: 280,
    borderRadius: 10,
    padding: 8,
    "@media (hover: none), (pointer: coarse)": {
      backgroundColor: theme.palette.error.main,
    },
  },
  arrow: {
    color: theme.palette.error.main,
    "@media (hover: none), (pointer: coarse)": {
      color: theme.palette.error.main,
    },
  },
}));

const UnavailableFeatureTooltip = ({ children, unavailable, title, forceOpen, spanStyle, ...props }) => {
  const classes = useUnavailableFeatureTooltipStyles();
  const [open, setOpen] = React.useState(false);
  const isOpen = unavailable && (forceOpen || open);

  const handleMouseEnter = () => {
    if (unavailable) {
      setOpen(true);
    }
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  const handleClick = (e) => {
    if (!unavailable) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  return (
    <Tooltip
      classes={classes}
      title={unavailable ? title : ""}
      open={isOpen}
      onClose={() => setOpen(false)}
      disableHoverListener
      disableFocusListener
      disableTouchListener
      {...props}
    >
      <span style={spanStyle || { display: "block", width: "100%" }} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleClick}>
        {children}
      </span>
    </Tooltip>
  );
};

export default UnavailableFeatureTooltip;